/**
 * [INPUT]: 依赖 @supabase/supabase-js 与 VITE_SUPABASE_* 环境变量
 * [OUTPUT]: 对外提供 supabase（anon Auth）与 supabaseAdmin（service_role）
 * [POS]: services/supabase 客户端入口；CMS 自举直连，无自建后端
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY
const SUPABASE_SERVICE_ROLE_KEY = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY

if (!SUPABASE_URL) {
  throw new Error('[Supabase] 缺少 VITE_SUPABASE_URL')
}

export const supabase = SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: localStorage,
        storageKey: 'zinner-cms-auth',
        flowType: 'pkce',
      },
    })
  : null

export const supabaseAdmin = SUPABASE_SERVICE_ROLE_KEY
  ? createClient(SUPABASE_URL, SUPABASE_SERVICE_ROLE_KEY, {
      auth: { autoRefreshToken: false, persistSession: false },
    })
  : null

if (!supabaseAdmin) {
  console.warn('[Supabase] 缺少 VITE_SUPABASE_SERVICE_ROLE_KEY，admin 查询不可用')
}

export default supabaseAdmin
